import { render } from "./SleepAndRest.vue?vue&type=template&id=3d5651fe&scoped=true"
const script = {}

import "./SleepAndRest.vue?vue&type=style&index=0&id=3d5651fe&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5651fe"]])

export default __exports__